'use strict';

var React = require('react');
var reactIcons = require('@sravni/react-icons');
var reactUtils = require('@sravni/react-utils');
var Icon = require('../../Icon/src/Icon.js');
var Sorter_module = require('../styles/Sorter.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const Sorter = (props) => {
    const { isSorted, ...restProps } = props;
    const cx = reactUtils.useStyles(Sorter_module.default);
    if (!isSorted) {
        return (React__namespace.createElement("div", { className: cx('container'), ...restProps },
            React__namespace.createElement(Icon.Icon, { className: cx('icon-sort'), icon: React__namespace.createElement(reactIcons.ArrowsSort, null) })));
    }
    if (isSorted === 'asc') {
        return (React__namespace.createElement("div", { className: cx('container'), ...restProps },
            React__namespace.createElement(Icon.Icon, { className: cx('icon-sort', 'fill', 'sort-asc'), icon: React__namespace.createElement(reactIcons.ArrowsSort, null) }),
            React__namespace.createElement(Icon.Icon, { className: cx('icon-sort'), icon: React__namespace.createElement(reactIcons.ArrowsSort, null) })));
    }
    return (React__namespace.createElement("div", { className: cx('container'), ...restProps },
        React__namespace.createElement(Icon.Icon, { className: cx('icon-sort', 'fill', 'sort-asc', 'sort-desc'), icon: React__namespace.createElement(reactIcons.ArrowsSort, null) }),
        React__namespace.createElement(Icon.Icon, { className: cx('icon-sort'), icon: React__namespace.createElement(reactIcons.ArrowsSort, null) })));
};

exports.Sorter = Sorter;
//# sourceMappingURL=Sorter.js.map
